import React, { useState, useEffect } from "react";
import SignInLayer from "../../components/SignInLayer";
import { loginRequest } from "../../api/auth";
import { useNavigate } from "react-router-dom";
import Toast from 'react-hot-toast';
import { Alert } from "bootstrap";

const Login = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  // Token varsa dashboarda yönlendir
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleLogin = async (email, password) => {
    try {
      setLoading(true);

      const res = await loginRequest(email, password);

      // JSON { token: "xyz", user: {...} }
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data));

      Toast.success("Giriş başarılı!");

      console.log(res);
      if (res.isTrue === true) {
        navigate("/dashboard");
      } else {
        Toast.error("Sistem hatası.. Giriş sağlanamadı.");
      }
    } catch (error) {
      Toast.error(error.message || "Giriş yapılamadı!");
    } finally {
      setLoading(false);
    }
  };

  return <SignInLayer onSubmit={handleLogin} loading={loading} />;
};

export default Login;